import React, { useState, useRef } from "react";
import convert from "image-file-resize";

export default function ImageResize() {
  const imageRef = useRef<HTMLImageElement>(null);
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [originalImageURL, setOriginalImageURL] = useState<string>("");
  const [resizedImageURL, setResizedImageURL] = useState<string>("");
  const [height, setHeight] = useState<string>("");
  const [width, setWidth] = useState<string>("");
  const [errors, setErrors] = useState<string>("");

  // Handle file selection
  const handleFileImage = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setImageFile(file);
      setOriginalImageURL(URL.createObjectURL(file));
      setResizedImageURL(""); // Reset resized image preview
    }
  };

  // Set dimensions when the original image is loaded
  const handleImageLoad = () => {
    if (imageRef.current) {
      setHeight(imageRef.current.naturalHeight.toString());
      setWidth(imageRef.current.naturalWidth.toString());
    }
  };

  // Resize the image
  const fileChangedHandler = async () => {
    if (!imageFile) {
      setErrors("Please select an image file.");
      return;
    }

    if (!width || !height) {
      setErrors("Please enter valid width and height.");
      return;
    }

    try {
      const resizedImage = await convert({
        file: imageFile,
        width: parseInt(width),
        height: parseInt(height),
        type: "jpeg",
      });
      setResizedImageURL(URL.createObjectURL(resizedImage));
      setErrors(""); // Clear errors
    } catch (err) {
      setErrors("An error occurred while resizing the image.");
    }
  };

  // Handle input changes for width and height
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;
    if (id === "height-input") {
      setHeight(value);
    } else if (id === "width-input") {
      setWidth(value);
    }
  };

  // Reset state for uploading a new image
  const resetHandler = () => {
    setImageFile(null);
    setOriginalImageURL("");
    setResizedImageURL("");
    setHeight("");
    setWidth("");
    setErrors("");
  };

  return (
    <>
      {!originalImageURL && (
        <div className="image-cropper-box-design-upload">
          <div className="icon-center-alignment">
            <i className="fa-solid fa-cloud-arrow-up"></i>
          </div>
          <p>
            Drag your image here, or click to <strong>browse</strong>
          </p>
          <input type="file" accept="image/*" onChange={handleFileImage} />
        </div>
      )}

      {originalImageURL && (
        <>
          <div className="image-cropper-box-design-upload-two">
            <div className="image-cropper-scale-grid">
              <div className="input-new">
                <label htmlFor="height-input">Height: </label>
                <input
                  id="height-input"
                  type="text"
                  placeholder="height"
                  value={height}
                  onChange={handleOnChange}
                />
              </div>
              <div className="input-new">
                <label htmlFor="width-input">Width: </label>
                <input
                  id="width-input"
                  type="text"
                  placeholder="maximum width 0-180 in % of height"
                  value={width}
                  onChange={handleOnChange}
                />
              </div>
            </div>
          </div>
          {errors && <div className="instruction-image-Resize">{errors}</div>}
          <div className="instruction-image-Resize">
            <span>
              * Modify the values and click the preview button to see the
              result.
            </span>
          </div>
        </>
      )}

      <div className="button reset-defaults-button-center-alignment">
        {originalImageURL && (
          <>
            <button onClick={fileChangedHandler}>Preview</button>
            <button onClick={resetHandler}>
              <i className="fa-sharp fa-solid fa-arrow-left"></i> Back to site
            </button>
          </>
        )}
        {resizedImageURL && (
          <>
            <a href={resizedImageURL} target="_blank" download>
              <button>
                <span>Download</span>
              </button>
            </a>
          </>
        )}
      </div>

      {resizedImageURL ? (
        <div className="crop-image-first-alignment">
          <img
            src={resizedImageURL}
            alt="Resized"
            className="canvas-img-style"
          />
        </div>
      ) : (
        originalImageURL && (
          <div className="crop-image-first-alignment">
            <img
              src={originalImageURL}
              alt="Original"
              ref={imageRef}
              onLoad={handleImageLoad}
            />
          </div>
        )
      )}
    </>
  );
}
